/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Rail_HighlightsInputs */

const en_directory_detail_rail_highlights = /** @type {(inputs: Directory_Detail_Rail_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highlights`)
};

const zh_directory_detail_rail_highlights = /** @type {(inputs: Directory_Detail_Rail_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`亮点`)
};

/**
* | output |
* | --- |
* | "Highlights" |
*
* @param {Directory_Detail_Rail_HighlightsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_rail_highlights = /** @type {((inputs?: Directory_Detail_Rail_HighlightsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Rail_HighlightsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_rail_highlights(inputs)
	return zh_directory_detail_rail_highlights(inputs)
});
export { directory_detail_rail_highlights as "directory.detail.rail.highlights" }